import React,{useEffect,useState} from 'react';
import AllStyles from './GlobalStyles';
import {Switch, Route, useLocation,useHistory} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import { isIE } from 'react-device-detect';
import Home from './pages/Home';
import Q1 from './pages/Question1';
import Q2 from './pages/Question2';
import Q3 from './pages/Question3';
import Q4 from './pages/Question4';
import Q5 from './pages/Question5';
import Thanks from './pages/Thanks';
import Error from './pages/Error';


const App = () => {

  const location = useLocation();
  const history = useHistory();

  const [q1,getQ1] = useState(50);
  const [q2,getQ2] = useState(50);
  const [q3,getQ3] = useState(50);
  const [q4,getQ4] = useState(50);
  const [q5,getQ5] = useState(30);

  useEffect(()=>{
    if(isIE) {
      return(
        <div>
          <h2>notice</h2>
            <p>Our servers have detected you are using an outdated browser!</p>
            <p>Unfortunately, this web application doesn't support your browser. Please use an alternative option - we recommend Google Chrome!</p>
        </div>
      )
    }
  },[])


  return (
    <div className="App">
      <AllStyles />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/" exact component={Home} />
          <Route path="/question1" render={()=> <Q1 q1={q1} getQ1={getQ1} />} />
          <Route path="/question2" render={()=> <Q2 q2={q2} getQ2={getQ2} />} />
          <Route path="/question3" render={()=> <Q3 q3={q3} getQ3={getQ3} />} />
          <Route path="/question4" render={()=> <Q4 q4={q4} getQ4={getQ4} />} />
          <Route path="/question5" render={()=> <Q5 q1={q1} q2={q2} q3={q3} q4={q4} q5={q5} getQ5={getQ5} />} />
          <Route path="/thank-you" render={()=> <Thanks />} />
          <Route path="/error" component={Error}  /> 
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
